import React from 'react'; 
import { Link } from 'react-router-dom';

import './SelectCard.css'

const SelectCard = ({img, title, url, disabled}) => {
  return(
    disabled ?
    <div className="linkCard">
      <div className="card-disabled">
        <img className="graph" src={img} alt={title} />
        <p className="title">{title}</p>
      </div>
    </div>
    
    :
    <Link to={url} className="linkCard">
      <div className="card">
        <img className="graph" src={img} alt={title} />
        <p className="title">{title}</p>
      </div>
    </Link>
  )
}

export default SelectCard;